// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { deviceId } from './Device';
import { operatorId } from './Operator';
import { z } from 'zod';
export const deviceLabelOverrideId = (z.number());
export const deviceLabelOverride = z.object({
    id: deviceLabelOverrideId,
    device_id: deviceId,
    affordance_id: z.string(),
    label: z.string(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
});
export const deviceLabelOverrideInitializer = z.object({
    id: deviceLabelOverrideId.optional(),
    device_id: deviceId,
    affordance_id: z.string(),
    label: z.string(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
export const deviceLabelOverrideMutator = z.object({
    id: deviceLabelOverrideId.optional(),
    device_id: deviceId.optional(),
    affordance_id: z.string().optional(),
    label: z.string().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=DeviceLabelOverride.js.map